import { unavailableOnWeb } from './unavailableOnWeb.web';
/**
 * Web stub for `react-native-keychain`, which has no web implementation.
 */
export var ACCESS_CONTROL;
(function (ACCESS_CONTROL) {
    ACCESS_CONTROL["USER_PRESENCE"] = "UserPresence";
})(ACCESS_CONTROL || (ACCESS_CONTROL = {}));
export const getSupportedBiometryType = unavailableOnWeb('Keychain.getSupportedBiometryType');
export const getGenericPassword = unavailableOnWeb('Keychain.getGenericPassword');
export const setGenericPassword = unavailableOnWeb('Keychain.setGenericPassword');
export const resetGenericPassword = unavailableOnWeb('Keychain.resetGenericPassword');
